import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import RecordCasinoReportUsers from 'views/reports/casinoReport/recordTableCasinoReport'; // Importing a specific report view
import { devConfig } from 'config/config'; // Importing development configuration
import tableLoteryReportView from 'jet-views/reports/loteryReport/tableLoteryReport'; // Importing another report view

/**
 * Class representing the lottery report view.
 * @extends JetView
 */
export default class recordLoteryReportView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The layout configuration object.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerAA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };

        // Left panel configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme, // Applying the current theme
                    elements: [
                        { view: 'label', label: _('Historial') }, // Label for the toolbar
                        {
                            type: 'wide',
                            css: 'close-bottom', // CSS class for styling
                            cols: [
                                {
                                    view: 'icon', // Icon button for closing
                                    icon: 'wxi-close', // Icon type
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigation on click
                                },
                            ],
                        },
                    ],
                },
                RecordCasinoReportUsers, // Including the casino report users component
                toolbar, // Adding the toolbar to the layout
            ],
        };

        // Returning the main layout configuration
        return {
            height: screen.width < 500 ? 350 : 0, // Responsive height based on screen width
            type: 'wide',
            cols: [left], // Main column layout
        };
    }
}

// FILE DOCUMENTED
